/**
 * HeaderCommon.ts
 * [Readme] --------------------------------------------------------------------------------------
 *
 * GNB에 적용하는 분양 리스트 데이터를 전달받도록 제어하는 기본 로직이 정의.
 *
 * -----------------------------------------------------------------------------------------------
 */

import { getSalesList } from 'common-modules/general/API/main';
import { ResponseSaleList } from 'common-modules/general/API/main/types';
import MobxAsyncModel from 'common-modules/general/Model/MobxAsyncModel';
import { RoutesString } from 'common-modules/general/Config/routesString';
import { makeAutoObservable, toJS } from 'mobx';

export interface GNBSubMenu {
  nmBizLnd: string;
  urlBizLndLnk: string;
  cdBizLnd: string;
}
export default class HeaderModel {
  public mainData: MobxAsyncModel<ResponseSaleList[]>;

  constructor() {
    this.mainData = new MobxAsyncModel(true);

    makeAutoObservable(this);
  }

  getData = () => {
    getSalesList()
      .then(({ data }) => {
        this.mainData.loadSuccess(data);
      })
      .catch(() => {
        this.mainData.loadFailure();
      });
  };

  /**
   * 메뉴 리스트를 위한 기본 메뉴 구조 작성
   */
  getMenuList = () => {
    const salesList = toJS(this.mainData.data);

    const menuList = [
      {
        nmBizLnd: '브랜드'
      },
      {
        nmBizLnd: '분양'
      },
      {
        nmBizLnd: '마이홈'
      }
    ];

    const other = {
      cdBizLnd: 'test',
      nmBizLnd: '연간분양일정',
      urlBizLndLnk: RoutesString.Schedule
    };

    const newSalesList = [other].concat(salesList ? salesList : []);
    const subMenuList = [
      {
        name: '브랜드',
        menuList: [
          {
            nmBizLnd: '브랜드 스토리',
            urlBizLndLnk: RoutesString.Brand,
            cdBizLnd: RoutesString.Brand
          },
          { nmBizLnd: '상품', urlBizLndLnk: RoutesString.Product, cdBizLnd: RoutesString.Product },
          { nmBizLnd: '기술', urlBizLndLnk: RoutesString.Skill, cdBizLnd: RoutesString.Skill },
          { nmBizLnd: '브랜드 뉴스', urlBizLndLnk: RoutesString.BrandNews, cdBizLnd: RoutesString.BrandNews }
        ]
      },

      {
        name: '분양',
        menuList: newSalesList
      },

      {
        name: '마이홈',
        menuList: [
          {
            nmBizLnd: '종합 정보',
            urlBizLndLnk: RoutesString.MyPage,
            cdBizLnd: RoutesString.MyPage
          },
          {
            nmBizLnd: '분양대금 납부 조회',
            urlBizLndLnk: RoutesString.Payment,
            cdBizLnd: RoutesString.Payment
          },
          {
            nmBizLnd: '입주자 사전방문행사 예약',
            urlBizLndLnk: RoutesString.FamilRV,
            cdBizLnd: RoutesString.FamilRV
          },
          {
            nmBizLnd: '입주 예약',
            urlBizLndLnk: RoutesString.MoveIn,
            cdBizLnd: RoutesString.MoveIn
          },
          {
            nmBizLnd: 'A/S 신청',
            urlBizLndLnk: RoutesString.AsSection01,
            cdBizLnd: RoutesString.AsSection01
          },
          {
            nmBizLnd: 'eLife 가이드',
            urlBizLndLnk: RoutesString.LivingGuide,
            cdBizLnd: RoutesString.LivingGuide
          },
          {
            nmBizLnd: '환기 필터 케어',
            urlBizLndLnk: RoutesString.Ventilation,
            cdBizLnd: RoutesString.Ventilation
          },
          {
            nmBizLnd: '단지 소식',
            urlBizLndLnk: RoutesString.Complex,
            cdBizLnd: RoutesString.Complex
          }
        ]
      }
    ];

    return { menuList, subMenuList };
  };
}
